import { render, staticRenderFns } from "./AddressBookLayout.vue?vue&type=template&id=808b1048&scoped=true"
import script from "./AddressBookLayout.vue?vue&type=script&lang=js"
export * from "./AddressBookLayout.vue?vue&type=script&lang=js"
import style0 from "./AddressBookLayout.vue?vue&type=style&index=0&id=808b1048&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808b1048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('808b1048')) {
      api.createRecord('808b1048', component.options)
    } else {
      api.reload('808b1048', component.options)
    }
    module.hot.accept("./AddressBookLayout.vue?vue&type=template&id=808b1048&scoped=true", function () {
      api.rerender('808b1048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/AddressBookLayout.vue"
export default component.exports